import { render } from "./Kernwoorden.vue?vue&type=template&id=4ceabaf1&scoped=true"
import script from "./Kernwoorden.vue?vue&type=script&lang=js"
export * from "./Kernwoorden.vue?vue&type=script&lang=js"

import "./Kernwoorden.vue?vue&type=style&index=0&id=4ceabaf1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ceabaf1"]])

export default __exports__